export default "__VITE_ASSET__fhO2R5pT__"